import { SyncOutlined } from "@ant-design/icons";
import { Flex, Progress, Spin } from "antd";

import { QueueProgress } from "@/hooks/useAsyncTaskQueue";

export const QueueItemProgress = ({
    progress,
}: {
    progress?: QueueProgress;
}) => {
    if (!progress?.isRunning) return null;

    return (
        <Flex align="center" gap={8}>
            <Spin indicator={<SyncOutlined spin />} size="small" />
            <Progress
                percent={(progress.completedCount / progress.totalCount) * 100}
                showInfo={false}
            />
        </Flex>
    );
};
